'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipIconComponent = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleTooltip = require('reactackle-tooltip');

var _reactackleCore = require('reactackle-core');

var _TooltipIconStyled = require('./styles/TooltipIconStyled');

var _theme = require('./styles/theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

(0, _reactackleCore.registerDefaultComponentTheme)('tooltipIcon', _theme2.default);
/**
 * Combined with tooltip
 */

var propTypes = {
  /**
   * Text of the Tooltip
   */
  text: _propTypes2.default.string.isRequired,

  /**
   * @ignore
   */
  toggleTooltip: _propTypes2.default.func,

  /**
   * @ignore
   */
  showTooltip: _propTypes2.default.func,

  /**
   * @ignore
   */
  hideTooltip: _propTypes2.default.func,

  /**
   * @ignore
   */
  Tooltip: _propTypes2.default.func
};
var defaultProps = {
  toggleTooltip: _reactackleCore.noop,
  showTooltip: _reactackleCore.noop,
  hideTooltip: _reactackleCore.noop,
  Tooltip: _reactackleCore.noop
};

var TooltipIconComponent = exports.TooltipIconComponent = function TooltipIconComponent(props) {
  var Tooltip = props.Tooltip;
  var wrapperProps = {
    onClick: props.toggleTooltip,
    onFocus: props.showTooltip,
    onBlur: props.hideTooltip,
    onMouseEnter: props.showTooltip,
    onMouseLeave: props.hideTooltip,
    tabIndex: 0
  };
  return _react2.default.createElement(_TooltipIconStyled.TooltipIconStyled, wrapperProps, _react2.default.createElement('span', null, '?'), _react2.default.createElement(Tooltip, null, props.text));
};

TooltipIconComponent.propTypes = propTypes;
TooltipIconComponent.defaultProps = defaultProps;
TooltipIconComponent.displayName = 'TooltipIcon';
exports.default = (0, _reactackleTooltip.withTooltip)(TooltipIconComponent, true);